import axios from 'axios'
import { auth } from '../../firebase'

export const getIdToken = () => {
  const currentUser = auth.currentUser
  return currentUser ? currentUser.getIdToken() : null
}

export default class ApiClient {
  constructor(baseUrl) {
    this._baseUrl = baseUrl
  }

  async _request({ path, ...otherConfig }) {
    const url = `${this._baseUrl}api/${path}`
    const idToken = await getIdToken()
    const headers = {
      'Content-Type': 'application/json'
    }
    if (idToken) {
      headers.Authorization = `Bearer ${idToken}`
    }

    const config = {
      url: url,
      headers,
      ...otherConfig
    }

    return axios(config)
  }

  get({ path }) {
    return this._request({ method: 'get', path })
  }

  post({ path, data = {} }) {
    return this._request({ method: 'post', path, data })
  }

  put({ path, data = {} }) {
    return this._request({ method: 'put', path, data })
  }

  delete({ path }) {
    return this._request({ method: 'delete', path })
  }
}
